import DirectDebitLettersMutation from '../../mutations/customer/DirectDebitLettersMutation.graphql';
import { EntityType } from '../../../@types/entityTypes';
import { ReportType } from '../../schema/p4types';

const DirectDebitRequestLine: EntityType = {
  type: 'DirectDebitRequestLine',
  title: 'Direct Debit Request Line',
  generate: DirectDebitLettersMutation,
  configuration: {
    title: 'Direct Debit Letter',
    field: 'directDebitLetterDefault',
    reportType: ReportType.DirectDebitLetter,
    customerField: 'customerDirectDebitLetterDefault',
    receiveFlag: 'receiveDirectDebitLetters',
  },
  screenReference: 'Direct Debit Request Line',
};

export default DirectDebitRequestLine;
